import { createGlobalStyle } from 'styled-components'

export const GlobalStyles = createGlobalStyle`

`
